import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { LockboxStatus, lockboxStatusTitle, voidReasonTitle  } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const useReturnCheckStatusFields = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const lockboxStatus = originalLockbox?.lockboxStatus;

  const actionTitle = useMemo(() => originalLockbox?.details?.processingDecision?.type
    ? lockboxStatusTitle?.[originalLockbox?.details?.processingDecision?.type as LockboxStatus]
    : '', [originalLockbox?.details?.processingDecision?.type]);

  const reasonTitle = useMemo(() => originalLockbox?.details?.processingDecision?.reason
    ? voidReasonTitle?.[originalLockbox?.details?.processingDecision?.reason]
    : '', [originalLockbox?.details?.processingDecision?.reason]);

  const isVoidCheck = useMemo(() => originalLockbox?.details?.processingDecision?.type === LockboxStatus.VOID,
    [originalLockbox?.details?.processingDecision?.type]);

  const fields = useMemo((): Field[] => {
    if ((lockboxStatus === LockboxStatus.APPROVED || lockboxStatus === LockboxStatus.PROCESSING || lockboxStatus === LockboxStatus.COMPLETED)
      && isVoidCheck) {
      return [
        {
          type: FieldTypes.Text,
          name: 'action',
          label: 'Action',
          value: actionTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text,
          name: 'voidReason',
          label: 'Void reason',
          value: reasonTitle || originalLockbox?.details?.processingDecision?.reason || EMPTY_FIELD_VALUE,
        },
      ];
    }

    return [];
  }, [lockboxStatus, actionTitle, reasonTitle, originalLockbox?.details?.processingDecision?.reason, isVoidCheck]);

  return fields;
};

export default useReturnCheckStatusFields;
